<template>
<div>


  <div   v-for=" item in foundData.displayIds" @click= 'select($event, item)'  :class="{'page_list_row-selected': item.add_info.selected}" class="selectable page_list_row clearfloat">

    <v-card
    primary
    hover
    :dark = "item.add_info.selected"
    class="selectable"

     >






        <div v-if="item.owner_type == 'group'">
  <v-list     >
             <v-list-tile avatar  >
               <v-list-tile-avatar>
                 <img :src="item.owner.photo_50">
               </v-list-tile-avatar>

               <v-list-tile-content>
                 <a class="non_decoration"  target="_blank" v-bind ='{href: "https://vk.com/club"+item.owner.id}'>
                 <v-list-tile-title  >   <span style="color:#4A76A8"> {{item.owner.name}}  </span> </v-list-tile-title>
                 </a>
                 <v-list-tile-sub-title  > {{item.date | dateFormat}}</v-list-tile-sub-title>
               </v-list-tile-content>
             </v-list-tile>

         </v-list>



        </div>
     <div v-if="item.owner_type == 'page'">
<v-list  >
           <v-list-tile avatar  >
             <v-list-tile-avatar>
               <img :src="item.owner.photo_50">
             </v-list-tile-avatar>

             <v-list-tile-content>
               <a class="non_decoration"  target="_blank" v-bind ='{href: "https://vk.com/id"+item.owner.id}'>
               <v-list-tile-title  > <span v-if="item.owner.online" style="color:green"> {{item.owner.first_name}} {{item.owner.last_name}} </span>  <span v-else style="color:#4A76A8"> {{item.owner.first_name}} {{item.owner.last_name}} </span> </v-list-tile-title>
             </a>
               <v-list-tile-sub-title  > {{item.date | dateFormat}}   </v-list-tile-sub-title>
             </v-list-tile-content>
           </v-list-tile>

       </v-list>


     </div>


<v-card-text class="selectable" >
  <div class="selectable" style="font-size:1.3em;overflow:hidden ">


    <span class="selectable" v-if="!item.readAll">{{item.text.slice(0,200)}}</span>
       <span @click="item.readAll = !item.readAll"  v-if="item.text.length>200 && !item.readAll" style="color:#4A76A8"> Читать польностью...</span>
          <span class="selectable" v-if="item.readAll">{{item.text}}</span>

  </div>



  <v-layout  v-if="item.photos">
     <v-flex  >
       <v-card flat>
         <v-container grid-list-sm fluid>
           <v-layout row wrap>
             <v-flex
               v-for="n in item.photos"
               :key="n.id"
               xs4
               d-flex
             >
               <v-card flat tile class="d-flex">
                 <v-img
                   :src="n.photo.photo_75"
                   aspect-ratio="1"
                   class="grey lighten-2"
                 >
                   <template v-slot:placeholder>
                     <v-layout
                       fill-height
                       align-center
                       justify-center
                       ma-0
                     >

                     </v-layout>
                   </template>
                 </v-img>
               </v-card>
             </v-flex>
           </v-layout>
         </v-container>
       </v-card>
     </v-flex>
   </v-layout>





</v-card-text>

<v-card-actions class="selectable">

 <v-btn flat>
 <v-icon left > mdi-thumb-up </v-icon>
 {{item.likes.count}}
 </v-btn>

 <v-btn flat>
 <v-icon> mdi-comment </v-icon>
 {{item.comments.count}}
 </v-btn>

 <v-btn flat>
 <v-icon> mdi-share </v-icon>
 {{item.reposts.count}}
 </v-btn>
<v-spacer></v-spacer>

<a class="non_decoration"  target="_blank" v-bind ='{href: "https://vk.com/wall"+item.ps_link}'>
 <v-btn small flat    >
   <span  v-if="!item.views"  style="color:#4A76A8 ; margin-right:5px">  Смотреть    </span>
 <v-icon  v-if="item.views"> mdi-eye </v-icon>
 <span style="margin-left:3px" v-if="item.views">{{item.views.count}}</span>
 </v-btn>
</a>


</v-card-actions>
    </v-card>

  </div>

  <v-btn   v-if="loadMore" :loading="this.loadingMore"  block flat  color="#4A76A8"  @click="offSetChanger(foundData,'posts')"
  >
    показать еще {{loadMore}}
   </v-btn>

</div>
</template>




<script>
import axios from 'axios'
export default {
  props: ['foundData'],
 data: function(){
  return {

 loadingMore:false,
  }
},
computed:{
 loadMore(){

   if(this.foundData.displayIds.length < 20){
     this.offSetChanger(this.foundData,'posts')
     return this.foundData.foundIds.length - this.foundData.displayIds.length
   } else return this.foundData.foundIds.length - this.foundData.displayIds.length
 },
},
methods: {
  offSetChanger (data,type) {
    this.foundData.foundIds = this.foundData.foundIds.filter(item=> item.length)
    let pagesString =  data.foundIds.slice(data.offset, data.offset+20)
    data.offset = data.offset+pagesString.length

  if(pagesString.join(',') !== ''){

    this.loadingMore = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_description.php', {
         method: 'POST',
         data: {
           dataType: type,
           dataString:  pagesString.join(','),
           addInfo:{selected:data.selector}
         }
       })
       .then( response => {
      if(response.data.result) { data.displayIds =   data.displayIds.concat(response.data.result)}
        this.loadingMore = false
       })
     } else {
        this.foundData.foundIds = this.foundData.foundIds.filter(item=> item.length)
      }
  },
  select: function(event,data){
    let classes = event.target.className.split(' ')

     if(classes.indexOf('selectable') !== -1){
       data.add_info.selected = !data.add_info.selected
        if(data.add_info.selected  ){

          this.foundData.selectedIds.push(data.ps_link)



        } else{



           this.foundData.selectedIds.splice(this.foundData.selectedIds.indexOf(data.ps_link),1)

        }

     //    event.target.className = 'page_list_row-selected'
   }


 },



},
filters:{

  dateFormat(item){
    var months = ['Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря'];

    let d =  new Date(item * 1000)
    let year =   d.getYear() - 100
    if(year < new Date().getYear()-100){year = " Год публикации "+year} else year = ""
    return  d.getDate()+" "+months[d.getMonth()]+" в "+ d.getHours() +":"+ d.getMinutes()  + year
  }
},
}
</script>

<style>
.labeled_name a {
  text-decoration: none;
  color: #42648b;
}
.topic_info{
  padding-left:10px;
padding-top: 10px;
float: left;
  margin-bottom: 5px;
margin-right: 25px;
  overflow: hidden;
  width: 370px;
min-height: 80px;
}
.page_list_row .topic_info .labeled_name{
    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
</style>
